import React, { useState, useRef } from 'react';
import api from '../services/api';

const FeedbackModal = () => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [replyEmail, setReplyEmail] = useState('');
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState('idle'); // idle | loading | success | error
    const fileRef = useRef();

    const handleFile = (e) => {
        const f = e.target.files[0];
        if (f) setFile(f);
    };

    const handleSubmit = async () => {
        if (!message.trim()) return;
        setStatus('loading');

        const form = new FormData();
        form.append('message', message);
        if (replyEmail.trim()) form.append('reply_email', replyEmail.trim());
        if (file) form.append('file', file);

        try {
            await api.post('/feedback', form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setStatus('success');
            setMessage('');
            setReplyEmail('');
            setFile(null);
            setTimeout(() => { setOpen(false); setStatus('idle'); }, 2000);
        } catch {
            setStatus('error');
        }
    };

    const handleClose = () => {
        setOpen(false);
        setStatus('idle');
        setMessage('');
        setReplyEmail('');
        setFile(null);
    };

    return (
        <>
            {/* Плавающая кнопка */}
            <button className="fb-trigger" onClick={() => setOpen(true)} title="Сообщить о проблеме">
                💬
            </button>

            {/* Оверлей */}
            {open && (
                <div className="fb-overlay" onClick={handleClose}>
                    <div className="fb-modal modern-card" onClick={e => e.stopPropagation()}>

                        <div className="fb-header">
                            <span className="fb-title">Сообщить о проблеме</span>
                            <button className="fb-close" onClick={handleClose}>✕</button>
                        </div>
                        <p className="fb-info">*Пожалуйста, расскажите нам о проблемах, с которыми вы столкнулись в результате работы с нашим сервисом. Любые ошибки или проблемы будут обработаны и исправлены в кратчайшие сроки*</p>

                        {status === 'success' ? (
                            <div className="fb-success">
                                ✅ Спасибо! Мы получили ваше сообщение.
                            </div>
                        ) : (
                            <>
                                <textarea
                                    className="fb-textarea"
                                    placeholder="Опишите проблему..."
                                    value={message}
                                    onChange={e => setMessage(e.target.value)}
                                    rows={5}
                                />

                                <input
                                    className="fb-email"
                                    type="email"
                                    placeholder="Email для ответа (необязательно)"
                                    value={replyEmail}
                                    onChange={e => setReplyEmail(e.target.value)}
                                />

                                {/* Загрузка файла */}
                                <div
                                    className="fb-file-area"
                                    onClick={() => fileRef.current.click()}
                                >
                                    {file
                                        ? <span className="fb-file-name">📎 {file.name}</span>
                                        : <span className="fb-file-hint">Прикрепить скриншот или файл</span>
                                    }
                                    <input
                                        ref={fileRef}
                                        type="file"
                                        accept="image/*,.pdf,.mp4"
                                        style={{ display: 'none' }}
                                        onChange={handleFile}
                                    />
                                </div>

                                {file && (
                                    <button className="fb-remove-file" onClick={() => setFile(null)}>
                                        Удалить файл
                                    </button>
                                )}

                                {status === 'error' && (
                                    <div className="fb-error">Ошибка отправки. Попробуйте снова.</div>
                                )}

                                <button
                                    className="btn-primary fb-submit"
                                    onClick={handleSubmit}
                                    disabled={status === 'loading' || !message.trim()}
                                >
                                    {status === 'loading' ? 'Отправка...' : 'Отправить'}
                                </button>
                            </>
                        )}

                    </div>
                </div>
            )}
        </>
    );
};

export default FeedbackModal;
